// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"44e80626","249":"35e84fd7","251":"bb28ce4f","345":"4946435b","374":"b8dc66c1","453":"20359781","467":"aef3adfa","507":"ff8a9c16","607":"4a941645","610":"95f707e4","765":"e698855b","778":"70399236","836":"bd349dc7"}[chunkId] + ".chunk.js";
};